import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import './polyfill';
import 'normalize.css';
import 'sanitize.css';
import './index.css';
export const disableReactDevTools = () => {
    const noop = () => undefined;
    const DEV_TOOLS = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (typeof DEV_TOOLS === 'object') {
        for (const [key, value] of Object.entries(DEV_TOOLS)) {
            DEV_TOOLS[key] = typeof value === 'function' ? noop : null;
        }
    }
};
// disableReactDevTools()
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
// registerServiceWorker()
// Hot reload
const hotModule = module.hot; // tslint:disable-line:no-any
if (hotModule) {
    hotModule.accept();
}
// Sentry
if (process.env.NODE_ENV === 'production') {
    // registerServiceWorker()
    unregisterServiceWorker();
    /*require('raven-js')
      .config('https://66b3256fb40e4783ad2458f3a13226aa@sentry.io/219864')
      .install()*/
}
// console.clear()



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 276
// module chunks = 0